var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcesscomplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.07 16.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #0072cb;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1.29,16.78c-.42-.11-.79-.32-1.03-.7C.09,15.82,0,15.54,0,15.23,0,11.02,0,6.81,0,2.61c0-.86.7-1.55,1.57-1.56.33,0,.65,0,.98,0,.11,0,.16-.03.21-.13C3.07.31,3.56,0,4.24,0c1.19,0,2.39,0,3.58,0,.68,0,1.18.31,1.48.92.05.1.11.13.21.13.33,0,.65,0,.98,0,.87,0,1.57.69,1.57,1.56,0,4.21,0,8.41,0,12.62,0,.67-.42,1.25-1.05,1.47-.08.03-.16.05-.23.08H1.29Zm-.22-7.86c0,2.04,0,4.08,0,6.12,0,.49.18.68.67.68,2.86,0,5.72,0,8.58,0,.5,0,.68-.18.68-.68,0-2.17,0-4.33,0-6.5,0-1.94,0-3.87,0-5.81,0-.4-.21-.61-.61-.61-.29,0-.59,0-.88,0-.1,0-.15.03-.2.12-.31.62-.8.93-1.49.93-1.18,0-2.37,0-3.55,0-.7,0-1.2-.31-1.51-.93-.04-.09-.09-.12-.19-.12-.28,0-.56,0-.83,0-.48,0-.67.18-.67.66,0,2.05,0,4.09,0,6.14ZM6.04,1.07c-.59,0-1.19,0-1.78,0-.4,0-.65.33-.53.68.07.21.28.35.56.35,1.17,0,2.33,0,3.5,0,.08,0,.16-.01.24-.04.34-.11.46-.54.22-.81-.12-.14-.28-.18-.46-.18-.58,0-1.17,0-1.75,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m5.1,12.07c-.15,0-.28-.05-.39-.17-.65-.7-1.31-1.39-1.95-2.09-.21-.23-.19-.57.03-.77.22-.21.56-.19.79.05.45.47.89.95,1.33,1.42.17.18.17.18.31-.01,1.2-1.57,2.4-3.15,3.6-4.73.15-.19.33-.3.58-.25.24.05.38.21.43.44.04.19-.04.34-.15.48-.65.85-1.3,1.71-1.95,2.56-.71.93-1.42,1.86-2.13,2.8-.12.16-.27.26-.49.26Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcesscomplete);
export default __webpack_public_path__ + "static/media/Process complete.1c8f8fae95281c869bed663b75aaa2e2.svg";
export { ForwardRef as ReactComponent };